import { ActivityIndicator, StyleSheet, Text, TextInput, View } from 'react-native'
import React, { useState } from 'react'
import { Units } from '../../constants/Unit'
import { GradientButton3 } from '../../components'
import { EDColors } from '../../constants/Colors'

const AccountManagementComponent = ({
  userData,
  onUpdatePassword,
  onSendResetLink,
  isUpdatingPassword,
  isSendingResetLink,
}) => {
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const handleUpdatePassword = () => {
    onUpdatePassword(newPassword, confirmPassword, () => {
      setNewPassword('')
      setConfirmPassword('')
    })
  }

  return (
    <View style={styles.container}>
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Update Password</Text>
        <Text style={styles.sectionDescription}>
          Set a new password directly for {userData?.email}.
        </Text>
        <TextInput
          value={newPassword}
          onChangeText={setNewPassword}
          placeholder="New password"
          secureTextEntry
          style={styles.input}
        />
        <TextInput
          value={confirmPassword}
          onChangeText={setConfirmPassword}
          placeholder="Confirm new password"
          secureTextEntry
          style={styles.input}
        />
        {isUpdatingPassword ? (
          <ActivityIndicator size="small" color={EDColors.gradient[1]} />
        ) : (
          <GradientButton3
            text="Update Password"
            handlePress={handleUpdatePassword}
            width={220}
          />
        )}
      </View>

      <View style={styles.divider} />

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Password Reset Link</Text>
        <Text style={styles.sectionDescription}>
          Send a password reset email to {userData?.email}. The user can set their own new password from the link.
        </Text>
        {isSendingResetLink ? (
          <ActivityIndicator size="small" color={EDColors.gradient[1]} />
        ) : (
          <GradientButton3
            text="Send Reset Link"
            handlePress={onSendResetLink}
            width={220}
          />
        )}
      </View>
    </View>
  )
}

export default AccountManagementComponent

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    color: '#010A41',
    fontSize: 20,
    fontFamily: Units.ftFamily.MontserratB,
    marginBottom: 8,
  },
  sectionDescription: {
    color: '#555',
    fontSize: 14,
    fontFamily: Units.ftFamily.MontserratR,
    marginBottom: 16,
    lineHeight: 20,
  },
  input: {
    backgroundColor: '#fff',
    padding: 12,
    borderRadius: 12,
    width: '100%',
    maxWidth: 400,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: '#ddd',
    fontFamily: Units.ftFamily.MontserratR,
    fontSize: 16,
  },
  divider: {
    backgroundColor: '#ccc',
    height: 1,
    width: '100%',
    marginBottom: 24,
  },
})
